import Machines_B_0 from './Machines_B/Machines_B_0'
import Machines_B_1 from './Machines_B/Machines_B_1'
import Machines_B_2 from './Machines_B/Machines_B_2'
import Machines_B_3 from './Machines_B/Machines_B_3'
import Machines_B_4 from './Machines_B/Machines_B_4'
import Machines_B_5 from './Machines_B/Machines_B_5'
import Machines_B_6 from './Machines_B/Machines_B_6'
import Machines_B_7 from './Machines_B/Machines_B_7'
import Machines_B_8 from './Machines_B/Machines_B_8'
import Machines_B_9 from './Machines_B/Machines_B_9'

const Machines_B = [
  Machines_B_0,
  Machines_B_1,
  Machines_B_2,
  Machines_B_3,
  Machines_B_4,
  Machines_B_5,
  Machines_B_6,
  Machines_B_7,
  Machines_B_8,
  Machines_B_9,
  null,
  null
]

export default Machines_B



// WEBPACK FOOTER //
// ./src/components/Machines_B.js